import { INSTRUMENT_CONFIGURATOR } from "constants/routes";
import { serviceRoles } from "config/access";
import { checkAccess } from "helpers/auth";
import InstrumentConfiguratorPage from "./container/InstrumentConfiguratorPage";

export default function getSettingsRoute(userAuth) {
  const { account } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: INSTRUMENT_CONFIGURATOR,
    withSidebar: false,
    withAppBar: false,
    component: InstrumentConfiguratorPage,
  };
}
